import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ThemeProvider } from "@mui/material/styles";
import { stockTableListTheme } from "../../styles/mui/tableListTheme";

import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { Box } from "@mui/material";
import { createRoletype } from "../../fetch/fetchType";

import Stack from "@mui/material/Stack";
import _ from "lodash";

export default function RoleManageCreateDialog(props) {
  const {
    open,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    fetchAll,
    department,
  } = props;

  const [formValidation, setFormvalidation] = React.useState({
    textField: "",
  });

  const [dialogValue, setdialogValue] = React.useState({
    textField: "",
  });

  const [selectedDept, setSelectedDept] = React.useState(1);

  const handleNameChange = (event) => {
    setdialogValue((prev) => ({
      ...prev,
      textField: event.target.value,
    }));
  };

  const handleOnClose = () => {
    setdialogValue({
      textField: "",
    });
    setFormvalidation({
      textField: "",
    });
    onClose();
  };

  const onSubmit = async () => {
    const reqBody = {
      role_types_name: dialogValue.textField,
      department_id: selectedDept,
    };

    const inValid = {
      textField: ["", undefined, null, " "].some(
        (item) => item === dialogValue.textField
      ),
    };

    setFormvalidation((prev) => ({
      ...prev,
      textField: inValid.textField ? "資料不能為空" : "",
    }));

    if (inValid.textField) {
      return false;
    } else {
      try {
        const { data } = await createRoletype(reqBody);
        if (data) {
          setSnackMessage("新增成功");
          setSnackSeverity("success");
          setSnackOpen(true);
          fetchAll();
        }
      } catch (err) {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
        setSnackOpen(true);
      } finally {
        handleOnClose();
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleOnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          新增職位
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <ThemeProvider theme={stockTableListTheme}>
            <Select
              value={selectedDept}
              onChange={(event) => {
                setSelectedDept(event.target.value);
              }}
            >
              {department.map((dept) => {
                return (
                  <MenuItem key={dept.id} value={dept.id}>
                    {dept.name}
                  </MenuItem>
                );
              })}
            </Select>
            <TextField
              helperText={formValidation.textField}
              label="類別"
              error={!!formValidation.textField}
              type="text"
              value={dialogValue.textField}
              onChange={handleNameChange}
            />
          </ThemeProvider>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose}>取消</Button>
        <Button onClick={onSubmit} type="submit">
          新增
        </Button>
      </DialogActions>
    </Dialog>
  );
}
